import Link from 'next/link';
import React from 'react';
import slugify from 'react-slugify';

import Image from '@/app/_components/Image';
import { useRoutesConfig } from '@/hooks/routes-config';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { DefaultButton } from '@/old-shared/components/buttons/default-button/default-button';
import { assetsUri } from '@/services/api.service';
import { getBrowseItemLink } from '@/services/link.service';
import {
  BrowseItemTypes,
  BrowseTypes,
  VehicleType,
} from '@/types/used-cars/used-cars.types';

import styles from './browse-location-item.module.scss';

export const BrowseLocationItem: React.FC<{
  item: BrowseItemTypes;
  name: BrowseTypes;
}> = ({ item, name }) => {
  const imageUri = `${assetsUri}/${item.image}?key=image-390-309`;
  const routes = useRoutesConfig();
  const { activeCarType } = useFiltersQuery();

  return item.image ? (
    <div className={styles.wrapper}>
      <Link
        className={styles.link}
        href={`${getBrowseItemLink(name, activeCarType, routes)}/${slugify(
          item.name,
        )}${activeCarType === VehicleType.Demo ? '?type=demo' : ''}`}
        prefetch={false}
      >
        <Image
          className={styles.image}
          src={imageUri}
          alt={item.fullName || ''}
          title={item.fullName || ''}
          width={390}
          height={309}
        />
        <h2 className={styles.text}>{item?.fullName ?? item?.name}</h2>
        <div className={styles.button}>
          <DefaultButton label="View Location" />
        </div>
      </Link>
    </div>
  ) : null;
};
